export default "__VITE_ASSET__D3yk362S__"